import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import MaterialTable from 'material-table'


const tableRef = React.createRef();
const sessionKeys = {
    search: 'enduringpromises.com.events.table.search'
};

const MaterialTableTable = () => {
    const columns = [
        {
            title: 'Title',
            field: 'title',
        },
        {
            title: 'Start Date',
            field: 'start_str',
        },
        {
            title: 'End Date',
            field: 'end_str',
        },
        {
            title: 'Duration',
            field: 'duration',
        }
    ];

    const [state, setState] = React.useState({ columns });

    const pageSizeOptions = [30, 50, 100, 250, 500];
    const [resultTotal, setResultTotal] = React.useState(0);
    const filteredPageSizeOptions = total => total > 0 ? pageSizeOptions : [0];

    const fetchData = query =>
        new Promise((resolve, reject) => {
            let url = '/api/events?';

            /* set the search to local storage */
            localStorage.setItem(sessionKeys.search, query.search);

            /* TODO: use orderBy and filters */
            url += 'per_page=' + query.pageSize
            url += '&page=' + (query.page + 1)
            url += '&search=' + query.search
            url += '&orderBy=' + (query.orderBy ? query.orderBy.field : '')
            url += '&orderDirection=' + query.orderDirection
            if (query.filters.length) {
                url += '&' + query.filters.map(x => `${x.column.field}=`+encodeURI(x.value)).join('&')
            }
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setResultTotal(result.total);
                    resolve({
                        data: result.data,
                        page: result.current_page - 1,
                        totalCount: result.total,
                    })
                })
            }
        )

    const defaultSearchText = localStorage.getItem(sessionKeys.search) || '';

    return (
        <React.Fragment>
            <MaterialTable
                title="Event List"
                columns={state.columns}
                data={fetchData}
                actions={[
                    {
                        icon: 'refresh',
                        tooltip: 'Refresh Data',
                        isFreeAction: true,
                        onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                    }
                ]}
                components={{
                    Container: Box,
                }}
                options={{
                    showTitle: false,
                    pageSize: 30,
                    pageSizeOptions: filteredPageSizeOptions(resultTotal),
                    exportButton: true,
                    loadingType: 'linear',
                    emptyRowsWhenPaging: false,
                    sorting: false,
                    debounceInterval: 600,
                    padding: 'dense',
                    searchText: defaultSearchText,
                }}
                tableRef={tableRef}
            />
        </React.Fragment>
    );
};


const EventsList = () => {
    return (
        <div style={{ maxWidth: '100%' }}>
            <Typography variant="h6">Events</Typography>
            <MaterialTableTable />
        </div>
    )
};

export default EventsList;
